const warehousepurchaseDt       = require('./warehousepurchase-dt')
const warehousepurchasePage     = require('./warehousepurchase-page')
const warehousepurchaseFullcont = require('./warehousepurchase-fullcont')
const warehousepurchaseQuickform =  require('./warehousepurchase-quickform')
const warehousepurchaseMenu            = require('./warehousepurchase-menu')
const purchaseMT       = require('./warehousepurchase-fullcont-multitable')


export function start(detail){   //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      dt:            { start: (detail)=>{  warehousepurchaseDt.start(detail)             }},
      page:          { start: (detail)=>{  warehousepurchasePage.start(detail)           }},
      fullcont:      { start: (detail)=>{  warehousepurchaseFullcont.start(detail)       }},
      multitable:    { start: (detail)=>{  purchaseMT.start(detail)                      }},
      quickform:     { start: (detail)=>{  warehousepurchaseQuickform.start(detail)      }},
      menu:     { start: (detail)=>{  warehousepurchaseMenu.start(detail)      }},

}








